module.exports = __webpack_public_path__ + "static/img/lixianrenwu.93ef181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/lixianrenwu.png
// module id = BJOZ
// module chunks = 24